import Link from "next/link";

const BreadcrumbComponent = ({ breadcrumbs }) => {
  if (breadcrumbs === undefined || breadcrumbs === null) return <></>;
  if (breadcrumbs?.length == 0) return <></>;

  return (
    <div className='w-100 d-flex bg-light py-md-4 py-3'>
      <nav className='container' aria-label='breadcrumb'>
        <ol className='breadcrumb mb-0'>
          <li className='breadcrumb-item' key={"bcHome00"}>
            <Link href='/' legacyBehavior>
              <a>Home</a>
            </Link>
          </li>
          <li className='breadcrumb-item d-block d-md-none' key={"bcHome01"}>
            <Link href='/' legacyBehavior>
              <a>...</a>
            </Link>
          </li>
          {breadcrumbs.map(function (item, idx) {
            return (
              <li className='breadcrumb-item' key={idx}>
                {item.link != null && (
                  <Link href={item.link} legacyBehavior>
                    <a>{item.title}</a>
                  </Link>
                )}
                {item.link == null && <>{item.title}</>}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default BreadcrumbComponent;
